import { render, staticRenderFns } from "./formFieldSwitch.vue?vue&type=template&id=5769b447"
import script from "./formFieldSwitch.vue?vue&type=script&lang=js"
export * from "./formFieldSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports